import React from "react";
import { observer } from "mobx-react";
import { Tooltip } from "antd";
import classNames from "classnames";

import Group from "../../group";
import TocIcon from "./toc-icon";
import "./style.scoped.scss";

const ReportDocumentStructureOverview = observer(
    ({ document, sections, readonly, onEdit, right }) => {
        const hasSections = !!sections?.length;

        if (!sections) {
            return null;
        }

        return (
            <Group title="Document Structure" onEdit={!readonly && onEdit} right={right}>
                <div className="structure">
                    {sections?.map((section) => {
                        const title = `${section.displayPos} ${section.title}`;
                        const level = section.pos.split("/").length;
                        const excluded = section.toc === false;

                        return (
                            <div
                                className={classNames("section", `level-${level}`, {
                                    "toc-excluded": excluded,
                                })}
                                key={section._id}
                            >
                                {title}
                                {excluded && (
                                    <Tooltip title="Excluded from TOC">
                                        <TocIcon excluded className="toc-excluded-icon" />
                                    </Tooltip>
                                )}
                            </div>
                        );
                    })}

                    {!hasSections && (
                        <div className="empty text-center p-10">
                            No sections are configured for this document
                        </div>
                    )}
                </div>
            </Group>
        );
    },
);

export default ReportDocumentStructureOverview;
